import React from "react";
import { Button, Grid, MenuItem, Paper, Stack, TextField, Typography } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import {
  MEAL_INITIAL_FILTERS,
  MEAL_PRIORITY_LABELS,
  MEAL_STATUS_LABELS,
  getMealTypeLabel,
} from "../mealIncidenciasUtils";

const MealIncidentFilters = ({ filters, typeOptions, onChange, onClear, disabled }) => (
  <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      gap={1}
      mb={1.5}
    >
      <Typography variant="h6" fontWeight={850} display="flex" alignItems="center" gap={1}>
        <FilterAltOutlinedIcon fontSize="small" />
        Filtros
      </Typography>
      <Button
        size="small"
        startIcon={<RestartAltOutlinedIcon />}
        onClick={onClear}
        disabled={disabled || Object.values(filters).every((value) => value === "")}
      >
        Limpiar
      </Button>
    </Stack>
    <Grid container spacing={1.5}>
      <Grid item xs={12} sm={6} lg={2}>
        <TextField
          select
          fullWidth
          size="small"
          label="Estado"
          value={filters.status}
          onChange={(event) => onChange("status", event.target.value)}
          disabled={disabled}
        >
          <MenuItem value="">Todos</MenuItem>
          {Object.entries(MEAL_STATUS_LABELS).map(([value, label]) => (
            <MenuItem value={value} key={value}>{label}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <TextField
          select
          fullWidth
          size="small"
          label="Prioridad"
          value={filters.priority}
          onChange={(event) => onChange("priority", event.target.value)}
          disabled={disabled}
        >
          <MenuItem value="">Todas</MenuItem>
          {Object.entries(MEAL_PRIORITY_LABELS).map(([value, label]) => (
            <MenuItem value={value} key={value}>{label}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <TextField
          select
          fullWidth
          size="small"
          label="Tipo"
          value={filters.type}
          onChange={(event) => onChange("type", event.target.value)}
          disabled={disabled}
        >
          <MenuItem value="">Todos</MenuItem>
          {typeOptions.map((type) => (
            <MenuItem value={type} key={type}>{getMealTypeLabel(type)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <TextField
          select
          fullWidth
          size="small"
          label="Condición"
          value={filters.conditionActive}
          onChange={(event) => onChange("conditionActive", event.target.value)}
          disabled={disabled}
        >
          <MenuItem value="">Todas</MenuItem>
          <MenuItem value="true">Condición activa</MenuItem>
          <MenuItem value="false">Ya no detectada</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <TextField
          fullWidth
          size="small"
          label="Desde"
          type="date"
          value={filters.dateFrom}
          onChange={(event) => onChange("dateFrom", event.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: filters.dateTo || undefined }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={2}>
        <TextField
          fullWidth
          size="small"
          label="Hasta"
          type="date"
          value={filters.dateTo}
          onChange={(event) => onChange("dateTo", event.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: filters.dateFrom || undefined }}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  </Paper>
);

MealIncidentFilters.defaultProps = {
  filters: MEAL_INITIAL_FILTERS,
  typeOptions: [],
};

export default MealIncidentFilters;
